import { DataGridPremium } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ExportExcelFromUrl from "../../../components/mui/app/exportExcelFromUrl/exportExcelFromUrl";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import CustomToolbar from "../../../components/mui/grids/dataGridCustom/customToolbar/customToolbar";
import { API } from "../../../helpers/constants";
import { muiGridLocales } from "../../../helpers/mui/muiLocales";
import { REPORTS } from "../locales/namespaces";

// const GridToolbar = ({ selectedStartDate, selectedEndDate, filterModel }) => {
// 	// console.log(filterModel)
// 	// debugger
// 	return (
// 		<CustomToolbar showExport={false}>
// 			<ExportExcelFromUrl url={`${API}/en/fts/reports/export`} data={{
// 				isActive: 0,
// 				reportType: 2,
// 				StartDt: dayjs(selectedStartDate).format('YYYY-MM-DD'),
// 				EndDt: dayjs(selectedEndDate).format('YYYY-MM-DD'),
// 				Filters: filterModel?.[0]?.predicates
//
// 			}}/>
// 		</CustomToolbar>
// 	)
// }

export function WorkerGridContainer({
										data,
										isLoading,
										page,
										pageSize,
										onFilterModelChange,
										onPaginationModelChange,
										onSortModelChange,
										total,
										language,
										dateFormat,
										selectedStartDate,
										selectedEndDate,
	

									}) {
	const { t } = useTranslation(REPORTS);

	const columns = useMemo(() => {
		return [
			{
				field: "Description",
				headerName: t("Worker"),
				minWidth: 300,
				flex: 1,
				// renderCell: ({ row }) => (
				// 	<Link
				// 		to={getRouteUrl(ROUTE_PAGE_PROJECT_DETAILS, {
				// 			projectId: row.id
				// 		})}
				// 	>
				// 		{row.Description}
				// 	</Link>
				// )
			},
			// {
			// 	field: "WorkDt",
			// 	headerName: t("Work Date"),
			// 	minWidth: 180,
			// 	flex: 1,
			// 	type: 'date',
			// 	valueFormatter: (value) =>
			// 		value ? dayjs(value).format(dateFormat) : null,
			// 	valueGetter: (value) => value && new Date(value)
			// },
			{
				field: "Projects",
				headerName: t("Projects"),
				minWidth: 300,
				flex: 1,
			},
			{
				field: "WorkTm",
				headerName: t("Work Time"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			{
				field: "WorkCost",
				headerName: t("Work Cost"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			{
				field: "ExtraWorkTm",
				headerName: t("Extra Work Time"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			// {
			// 	field: "ExtraWorkTmW",
			// 	headerName: t("Extra Work Time(S-S)"),
			// 	minWidth: 120,
			// 	flex: 1,
			// 	type: 'number',
			// 	valueGetter: (value) => value ? Number(value) : 0.00,
			// 	aggregationFunction: 'sum',
			// 	// valueFormatter: (params) => params.value.toFixed(2),
			// },
			{
				field: "ExtraWorkCost",
				headerName: t("Extra Work Cost"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			{
				field: "WithContribution",
				headerName: t("Payment"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
				// aggregationMethod: (values) => (values).reduce((sum, current) => sum + current, 0),
			},
			// {
			// 	field: "ExtraWorkCostW",
			// 	headerName: t("Extra Work Cost(S-S)"),
			// 	minWidth: 120,
			// 	flex: 1,
			// 	type: 'number',
			// 	valueGetter: (value) => value ? Number(value) : 0.00,
			// 	aggregationFunction: 'sum',
			// 	// valueFormatter: (params) => params.value.toFixed(2),
			// },
			{
				field: "WithContibutions",
				headerName: t("With Contibutions day"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				aggregationFunction: 'sum',
				// valueFormatter: (params) => params.value.toFixed(2),
				// aggregationMethod: (values) => (values).reduce((sum, current) => sum + current, 0),
			},
		
		];
	}, [t]);
	
	return (
		
		<DataGridPremium
			sx={{
				'& .MuiDataGrid-headerFilterRow': {
					background: `linear-gradient(90deg, #e2e7e3 05%, #f6f7f7 95%)`
				},
				'& .MuiFormLabel-root': {
					display: 'none',
				},
				'& .MuiDataGrid-pinnedRowBottom .MuiDataGrid-cell': {
					color: 'black',
					fontWeight: 'bold',
				},
				'& .MuiDataGrid-footerCell': {
					color: 'black',
					fontWeight: 'bold',
				}
			}}
			columns={columns}
			rows={data}
			pagination
			paginationModel={{ page, pageSize }}
			paginationMode="server"
			onPaginationModelChange={onPaginationModelChange}
			rowCount={Number(total)}
			pageSizeOptions={[5, 10, 15, 20, 50, 100]}
			sortingMode="server"
			onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
			filterMode="server"
			onFilterModelChange={onFilterModelChange}
			loading={isLoading}
			initialState={{
				density: 'compact',
				aggregation: {
					model: {
						WorkTm: 'sum',
						ExtraWorkTm: 'sum',
						//ExtraWorkTmW: 'sum',
						WorkCost: 'sum',
						ExtraWorkCost: 'sum',
						//ExtraWorkCostW: 'sum',
						WithContribution: 'sum',
						WithContibutions: 'sum',
					},
				},
				// aggregationRowsScope: 'bottom',
			}}
			slots={{
				pagination: CustomPagination,
				headerFilterMenu: null,
			}}
			disableColumnFilter
			headerFilters
			localeText={muiGridLocales(language)}
		/>
	);
}
